import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { value } from "../../config/data";
import axiosInstance from "../../config/axiosInterceptor";

function getPreviousWeekSaturdayToMonday() {
    const now = new Date();
    const day = now.getDay(); // 0 = Sun, 1 = Mon, ..., 6 = Sat

    // Get this week's Monday
    const thisMonday = new Date(now);
    const diffToMonday = (day + 6) % 7; // days to subtract to get to Monday
    thisMonday.setDate(now.getDate() - diffToMonday);
    thisMonday.setHours(23, 59, 59, 999);

    // Previous week's Saturday is 2 days before that Monday
    const lastSaturday = new Date(thisMonday);
    lastSaturday.setDate(thisMonday.getDate() - 2);
    lastSaturday.setHours(0, 0, 0, 0);

    return {
        start: lastSaturday,
        end: thisMonday,
    };
}

const TotalWithdrawalAgencyForInvoice = () => {
    const [showKycModal, setShowKycModal] = useState(false);
    const [selectedKycDetails, setSelectedKycDetails] = useState(null);

    const openKycModal = (kycData) => {
        setSelectedKycDetails(kycData);
        setShowKycModal(true);
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [entriesPerPage, setEntriesPerPage] = useState(5);
    const [widthdrawalList, setWithdrawalLists] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedAgencies, setSelectedAgencies] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const [generating, setGenerating] = useState(false);
    const [startDateChosen, setStartDateChosen] = useState("");
    const [endDateChosen, setEndDateChosen] = useState("");

    const { start: lastSaturdayDate, end: followingMondayDate } = getPreviousWeekSaturdayToMonday();
    const startDate = lastSaturdayDate.toISOString().split("T")[0];
    const endDate = followingMondayDate.toISOString().split("T")[0];

    const totolSumOfWithdrawalA = widthdrawalList.reduce((acc, total) => {
        return acc + parseFloat((((total?.totalDollor) * value.USDINR) * value.agencyComm).toFixed(2));
    }, 0);
    const totolSumOfWithdrawalH = widthdrawalList.reduce((acc, total) => {
        return acc + parseFloat(((total?.totalDollor) * value.USDINR).toFixed(2));
    }, 0);
    const TdsAmount = totolSumOfWithdrawalA * 0.10;
    const CommissionAfterTds = totolSumOfWithdrawalA - TdsAmount;
    const totolSumOfWithdrawal = totolSumOfWithdrawalA + totolSumOfWithdrawalH;
    const totalPayable = totolSumOfWithdrawalH + CommissionAfterTds;

    const getBdLists = async () => {
        try {
            setLoading(true);
            const page = currentPage || 1;
            const skip = (currentPage - 1) * entriesPerPage;
            const limit = entriesPerPage;
            const { data } = await axiosInstance.get(
                `${process.env.REACT_APP_BASEURL3}/admin/withdrawal/WithAgencyForInvoice?start=${startDateChosen}&end=${endDateChosen}&page=${page}&limit=${limit}`
            );
            if (data.success === 1) {
                setWithdrawalLists(data.details);
                setTotalCount(data.totalCount || 0);
            }
            setLoading(false);
        } catch (error) {
            console.log(error.message);
        }
    };

    useEffect(() => {
        getBdLists();
    }, [startDate, endDate, currentPage, entriesPerPage, startDateChosen, endDateChosen]);

    useEffect(() => {
        if (startDate && endDate) {
            setStartDateChosen(startDate);
            setEndDateChosen(endDate);
        }
    }, [startDate, endDate]);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const handleCheckboxChange = (agencyId) => {
        if (selectedAgencies.includes(agencyId)) {
            setSelectedAgencies(selectedAgencies.filter(id => id !== agencyId));
        } else {
            setSelectedAgencies([...selectedAgencies, agencyId]);
        }
    };

    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedAgencies([]);
        } else {
            const allAgencyIds = widthdrawalList.map(item => item.agency);
            setSelectedAgencies(allAgencyIds);
        }
        setSelectAll(!selectAll);
    };

    const submitBills = async () => {
        alert(`Bill will only be generated for previous week from ${startDate} to ${endDate}`);
        setGenerating(true);

        for (let agencyId of selectedAgencies) {
            const agencyData = widthdrawalList.find(a => a.agency === agencyId);
            if (!agencyData) continue;

            const totalAmount = ((agencyData.totalDollor || 0) * value.USDINR * value.agencyComm).toFixed(2);

            try {
                const { data } = await axios.post(`${process.env.REACT_APP_BASEURL3}/admin/withdrawal/submitBdBill`, {
                    invoiceForType: "agency",
                    invoiceFor: agencyId,
                    totalAmount,
                    startDate,
                    endDate,
                });
                console.log(data.message);
            } catch (err) {
                console.error(`Error submitting bill for ${agencyId}:`, err.message);
            }
        }

        alert("Bill submission complete.");
        setGenerating(false);
        setSelectedAgencies([]);
        setSelectAll(false);
        getBdLists();
    };

    const handleExportCSV = () => {
        const selectedRows = widthdrawalList.filter(item => selectedAgencies.includes(item.agency));

        // Utility function to wrap and escape values
        const escapeCSV = (value) => {
            const str = String(value ?? "");
            if (str.includes(",") || str.includes('"') || str.includes("\n")) {
                return `"${str.replace(/"/g, '""')}"`; // escape internal quotes
            }
            return str;
        };

        const csvContent = [
            [
                "Agency ID", "Agency Name", "HostAmount", "Commission", "TDS",
                "CommissionAfterTds", "Total Payable",
                "PAN", "Aadhaar", "Aadhaar Name", "DOB", "Gender", "Address",
                "Bank Name", "Bank Account No.", "IFSC", "Holder Name",
                "Calling Number", "Email", "Mobile Number", "Verify Mobile", "KYC Verified", "Admin Approved"
            ],
            ...selectedRows.map(item => {
                const inr = (item.totalDollor * value.USDINR).toFixed(2);
                const commission = (item.totalDollor * value.USDINR * value.agencyComm).toFixed(2);
                const tds = (commission * 0.10).toFixed(2);
                const commissionAfterTds = (parseFloat(commission) - parseFloat(tds)).toFixed(2);
                const totalPayable = (parseFloat(inr) + parseFloat(commissionAfterTds)).toFixed(2);

                return [
                    item.agency,
                    item.agencyName,
                    inr,
                    commission,
                    tds,
                    commissionAfterTds,
                    totalPayable,
                    item.panNumber,
                    item.aadhaarNumber,
                    item.aadhaarName,
                    item.dob,
                    item.gender,
                    item.address,
                    item.bankName,
                    item.bankAccountNumber,
                    item.bankAccountIFSC,
                    item.bankAccountHolderName,
                    item.callingNumber,
                    item.email,
                    item.number,
                    item.verifyNumber ? "Yes" : "No",
                    item.kycVerified ? "Yes" : "No",
                    item.adminApproved
                ].map(escapeCSV); // apply escaping to each field
            }),
        ];

        const csvString = csvContent.map(row => row.join(",")).join("\n");
        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "selected_agencies.csv";
        link.click();
    };


    const totalPages = Math.ceil(totalCount / entriesPerPage);

    return (
        <>
            <section className="content-header">
                <h1 style={{ fontWeight: "bold", animation: "fadeIn 1s ease" }}>📦 Agency Withdrawal Dashboard</h1>
                <ol className="breadcrumb">
                    <li><Link to="/admin"><i className="fa fa-dashboard"></i> Home</Link></li>
                    <li className="active">Withdrawals</li>
                </ol>
            </section>

            <section className="content" style={{ animation: "fadeIn 1s ease" }}>
                <div className="box">
                    <div style={{ margin: "20px", display: "flex", gap: "15px", flexWrap: "wrap" }}>
                        <div>
                            <label>Start Date</label><br />
                            <input type="date" className="form-control" value={startDateChosen || ""} onChange={(e) => setStartDateChosen(e.target.value)} />
                        </div>
                        <div>
                            <label>End Date</label><br />
                            <input type="date" className="form-control" value={endDateChosen || ""} onChange={(e) => setEndDateChosen(e.target.value)} />
                        </div>
                        <div>
                            <label>Entries/Page</label><br />
                            <select className="form-control" value={entriesPerPage} onChange={(e) => setEntriesPerPage(Number(e.target.value))}>
                                <option value={10}>10</option>
                                <option value={100}>100</option>
                                <option value={200}>200</option>
                            </select>
                        </div>
                        {selectedAgencies.length > 0 && (
                            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                <div style={{ color: "#d9534f", fontWeight: "bold" }}>
                                    Week Range: {startDate} ➡️ {endDate}
                                </div>
                                <button style={{ padding: "10px", backgroundColor: "#28a745", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer", transition: "0.3s" }}
                                    onClick={submitBills}>{generating ? "Generating..." : `✅ Generate Bill (${selectedAgencies.length})`}</button>
                                <button style={{ padding: "10px", backgroundColor: "#007bff", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer" }}
                                    onClick={handleExportCSV}>📥 Export CSV</button>
                            </div>
                        )}
                    </div>

                    <div
                        style={{
                            background: "#f0f7ff",
                            padding: "12px 16px",
                            borderRadius: "8px",
                            border: "1px solid #b3d7ff",
                            margin: "20px auto",
                            fontSize: "14px",
                            fontFamily: "monospace",
                            lineHeight: "1.6",
                            animation: "fadeIn 0.5s ease-in-out",
                            maxWidth: "420px",
                            boxShadow: "0 2px 5px rgba(0,0,0,0.05)"
                        }}
                    >
                        <div style={{ fontWeight: "bold", fontSize: "15px", marginBottom: "8px" }}>
                            💼 Summary
                        </div>

                        <div>
                            Host INR - <strong>₹{totolSumOfWithdrawalH.toFixed(2)}</strong><br />
                            + Commission - <strong>₹{totolSumOfWithdrawalA.toFixed(2)}</strong><br />
                            - TDS (10%) - <strong>₹{TdsAmount.toFixed(2)}</strong><br />
                            = Commission After TDS - <strong>₹{CommissionAfterTds.toFixed(2)}</strong><br />
                            Payable Total - <strong>₹{totalPayable.toFixed(2)}</strong>
                        </div>
                    </div>
                    {showKycModal && selectedKycDetails && (
                        <div
                            style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                background: "rgba(0,0,0,0.6)",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                zIndex: 9999,
                            }}
                        >
                            <div
                                style={{
                                    background: "#fff",
                                    padding: "20px",
                                    borderRadius: "10px",
                                    maxWidth: "800px",
                                    width: "90%",
                                    overflowY: "auto",
                                    maxHeight: "90vh",
                                }}
                            >
                                <h3 style={{ marginBottom: "15px" }}>📄 KYC Details</h3>

                                {/* Agency & Identity */}
                                <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", fontSize: "14px" }}>
                                    <div style={{ flex: "1 1 45%" }}><strong>Agency ID:</strong> {selectedKycDetails.agency}</div>
                                    <div style={{ flex: "1 1 45%" }}><strong>Agency Name:</strong> {selectedKycDetails.agencyName}</div>
                                    <div style={{ flex: "1 1 45%" }}><strong>BD:</strong> {selectedKycDetails.bd}</div>
                                    <div style={{ flex: "1 1 45%" }}><strong>Agency Admin:</strong> {selectedKycDetails.agencyadmin}</div>
                                    <div style={{ flex: "1 1 45%" }}><strong>Aadhaar Number:</strong> {selectedKycDetails.aadhaarNumber}</div>
                                    <div style={{ flex: "1 1 45%" }}><strong>PAN Number:</strong> {selectedKycDetails.panNumber}</div>
                                    <div style={{ flex: "1 1 45%" }}><strong>Aadhaar Name:</strong> {selectedKycDetails.aadhaarName}</div>
                                    <div style={{ flex: "1 1 45%" }}><strong>DOB:</strong> {selectedKycDetails.dob}</div>
                                    <div style={{ flex: "1 1 45%" }}><strong>Gender:</strong> {selectedKycDetails.gender}</div>
                                    <div style={{ flex: "1 1 100%" }}><strong>Address:</strong> {selectedKycDetails.address}</div>
                                    <div style={{ flex: "1 1 45%" }}><strong>Bank Name:</strong> {selectedKycDetails.bankName}</div>
                                    <div style={{ flex: "1 1 45%" }}><strong>Account No:</strong> {selectedKycDetails.bankAccountNumber}</div>
                                    <div style={{ flex: "1 1 45%" }}><strong>IFSC:</strong> {selectedKycDetails.bankAccountIFSC}</div>
                                    <div style={{ flex: "1 1 45%" }}><strong>Holder Name:</strong> {selectedKycDetails.bankAccountHolderName}</div>
                                    <div style={{ flex: "1 1 45%" }}><strong>Mobile:</strong> {selectedKycDetails.number}</div>
                                    <div style={{ flex: "1 1 45%" }}><strong>Calling Number:</strong> {selectedKycDetails.callingNumber}</div>
                                    <div style={{ flex: "1 1 45%" }}><strong>Email:</strong> {selectedKycDetails.email}</div>
                                    <div style={{ flex: "1 1 45%" }}><strong>Mobile Verified:</strong> {selectedKycDetails.verifyNumber ? "Yes" : "No"}</div>
                                    <div style={{ flex: "1 1 45%" }}><strong>KYC Verified:</strong> {selectedKycDetails.kycVerified ? "Yes" : "No"}</div>
                                    <div style={{ flex: "1 1 45%" }}><strong>Admin Approved:</strong> {selectedKycDetails.adminApproved || "N/A"}</div>
                                </div>

                                {/* 💸 Financial Summary */}
                                <div style={{ marginTop: 25 }}>
                                    <h4>💸 Financial Summary</h4>
                                    {(() => {
                                        const usdToInr = value.USDINR;
                                        const agencyComm = value.agencyComm;
                                        const inr = (selectedKycDetails.totalDollor * usdToInr).toFixed(2);
                                        const commission = (selectedKycDetails.totalDollor * usdToInr * agencyComm).toFixed(2);
                                        const tds = (commission * 0.10).toFixed(2);
                                        const commissionAfterTds = (parseFloat(commission) - parseFloat(tds)).toFixed(2);
                                        const totalPayable = (parseFloat(inr) + parseFloat(commissionAfterTds)).toFixed(2);

                                        return (
                                            <div style={{ fontSize: "14px", lineHeight: "1.6" }}>
                                                <div><strong>Total Withdrawal (Host):</strong> ₹{inr}</div>
                                                <div><strong>Agency Commission:</strong> ₹{commission}</div>
                                                <div><strong>TDS (10%):</strong> -₹{tds}</div>
                                                <div><strong>Commission After TDS:</strong> ₹{commissionAfterTds}</div>
                                                <div><strong>Total Payable:</strong> ₹{totalPayable}</div>
                                            </div>
                                        );
                                    })()}
                                </div>

                                {/* 🖼 Document Images */}
                                <div style={{ marginTop: 25 }}>
                                    <h4>🖼 Documents</h4>
                                    <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                                        {selectedKycDetails.aadhaarFrontUrl && (
                                            <div>
                                                <div>Aadhaar Front</div>
                                                <img src={process.env.REACT_APP_BASEURL + selectedKycDetails.aadhaarFrontUrl} alt="Aadhaar Front" style={{ width: 120 }} />
                                            </div>
                                        )}
                                        {selectedKycDetails.aadhaarBackUrl && (
                                            <div>
                                                <div>Aadhaar Back</div>
                                                <img src={process.env.REACT_APP_BASEURL + selectedKycDetails.aadhaarBackUrl} alt="Aadhaar Back" style={{ width: 120 }} />
                                            </div>
                                        )}
                                        {selectedKycDetails.panUrl && (
                                            <div>
                                                <div>PAN Card</div>
                                                <img src={process.env.REACT_APP_BASEURL + selectedKycDetails.panUrl} alt="PAN" style={{ width: 120 }} />
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* 📹 Video Proof */}
                                {selectedKycDetails.videoUrl && (
                                    <div style={{ marginTop: 25 }}>
                                        <h4>📹 KYC Video</h4>
                                        <video src={process.env.REACT_APP_BASEURL + selectedKycDetails.videoUrl} controls style={{ width: "100%", borderRadius: "6px" }} />
                                    </div>
                                )}

                                {/* Close Button */}
                                <button
                                    onClick={() => setShowKycModal(false)}
                                    style={{
                                        marginTop: 20,
                                        backgroundColor: "#d9534f",
                                        color: "#fff",
                                        padding: "10px 16px",
                                        border: "none",
                                        borderRadius: "5px",
                                        cursor: "pointer",
                                    }}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    )}




                    <table className="table table-bordered" style={{ animation: "fadeIn 0.5s ease-in" }}>
                        <thead style={{ backgroundColor: "#e3f2fd" }}>
                            <tr>
                                <th><input type="checkbox" onChange={handleSelectAll} checked={selectAll} /></th>
                                <th>#</th>
                                <th>Agency ID</th>
                                <th>Agency Name</th>
                                <th>W. Coins</th>
                                <th>HostAmount(₹)</th>
                                <th>Commission(₹)</th>
                                <th>TDS(₹)</th>
                                <th style={{ maxWidth: "120px" , textWrap:"auto"}}>Commission After TDS (Commission - TDS) (₹)</th>
                                <th style={{ maxWidth: "120px", textWrap:"auto" }}>Total Payable (Host + Commission - TDS) (₹)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan="10">Loading...</td></tr>
                            ) : widthdrawalList.length === 0 ? (
                                <tr><td colSpan="10">No data found</td></tr>
                            ) : (
                                widthdrawalList.map((item, index) => {
                                    const agencyId = item.agency;
                                    const inr = (item.totalDollor * value.USDINR).toFixed(2);
                                    const commission = (item.totalDollor * value.USDINR * value.agencyComm).toFixed(2);
                                    const tds = (commission * 0.10).toFixed(2);
                                    const commissionAfterTds = (parseFloat(commission) - parseFloat(tds)).toFixed(2);
                                    const totalPayable = (parseFloat(inr) + parseFloat(commissionAfterTds)).toFixed(2);

                                    return (
                                        <tr key={agencyId} style={{ animation: "fadeIn 0.4s ease-in" }}>
                                            <td><input type="checkbox" checked={selectedAgencies.includes(agencyId)} onChange={() => handleCheckboxChange(agencyId)} /></td>
                                            <td>{(currentPage - 1) * entriesPerPage + index + 1}</td>
                                            <td>{agencyId}</td>
                                            <td>{agencyId}</td>
                                            <td>{item.totalAmount}</td>
                                            <td>{inr}</td>
                                            <td>{commission}</td>
                                            <td style={{ color: "red" }}>-{tds}</td>
                                            <td>{commissionAfterTds}</td>
                                            <td style={{ color: "green" }}>{totalPayable}</td>
                                            <td>
                                                <ul
                                                    className="admin-action btn btn-default"
                                                    style={{
                                                        backgroundColor: "#f4f4f4",
                                                        color: "#fff !important",
                                                    }}
                                                >
                                                    {/* ... (your existing dropdown menu items) */}
                                                    <li className="dropdown">
                                                        <a
                                                            className="dropdown-toggle"
                                                            style={{ color: "black" }}
                                                            data-toggle="dropdown"
                                                            href="#"
                                                            aria-expanded="false"
                                                        >
                                                            Action  
                                                        </a>
                                                        <ul className="dropdown-menu dropdown-menu-right">
                                                            <li role="presentation">
                                                                <Link
                                                                    role="menuitem"
                                                                    tabIndex={-1}
                                                                    to={`/admin/storedwithdrawalAAlists?agency=${item?.agency}&bd=${item?.bd}&agencyadmin=${item?.agencyadmin}&start=${startDateChosen}&end=${endDateChosen}`}
                                                                >
                                                                    Host Details
                                                                </Link>
                                                            </li>
                                                            <li role="presentation">
                                                                <button className="dropdown-item" onClick={() => openKycModal(item)}>
                                                                    View KYC
                                                                </button>
                                                            </li>


                                                        </ul>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </table>

                    <div style={{ display: "flex", justifyContent: "center", margin: "20px", gap: "10px" }}>
                        <button disabled={currentPage === 1} onClick={() => paginate(currentPage - 1)} style={{ padding: "8px 12px", borderRadius: "6px", background: "#6c757d", color: "#fff", border: "none" }}>
                            Prev
                        </button>
                        <span>Page {currentPage} of {totalPages}</span>
                        <button disabled={currentPage === totalPages} onClick={() => paginate(currentPage + 1)} style={{ padding: "8px 12px", borderRadius: "6px", background: "#6c757d", color: "#fff", border: "none" }}>
                            Next
                        </button>
                    </div>

                    <style>
                        {`
              @keyframes fadeIn {
                from { opacity: 0; transform: translateY(10px); }
                to { opacity: 1; transform: translateY(0); }
              }
            `}
                    </style>
                </div>
            </section>
        </>
    );
};

export default TotalWithdrawalAgencyForInvoice;

